import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4c0eb06a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4c0eb06a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0eb06a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c0eb06a')) {
      api.createRecord('4c0eb06a', component.options)
    } else {
      api.reload('4c0eb06a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4c0eb06a&scoped=true", function () {
      api.rerender('4c0eb06a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/enterprise/setup/index.vue"
export default component.exports